import * as React from "react";
import { Link } from "gatsby";
import Image from "../image/image";
import { EventAttributes, getEventAttributes } from "../../../utils/analytics";
import styles from "./image-card.styles";

interface ImageCardProps {
  title: string;
  description: string;
  ctaTitle: string;
  url: string;
  imageUrl: string;
  isExternal?: boolean;
  analytics: EventAttributes;
}

const ImageCard: React.FC<ImageCardProps> = ({
  title,
  description,
  ctaTitle,
  url,
  imageUrl,
  isExternal,
  analytics,
}) => {
  const content = (
    <>
      <div css={styles.image}>
        <Image src={imageUrl} alt={title} />
      </div>
      <div css={styles.content}>
        <div css={styles.title}>{title}</div>
        <div css={styles.description}>{description}</div>
        <div css={styles.ctaText}>{ctaTitle}</div>
      </div>
    </>
  );

  return isExternal ? (
    <a href={url} css={styles.root} target="_blank" rel="noreferrer">
      {content}
    </a>
  ) : (
    <Link to={url} css={styles.root} {...getEventAttributes(analytics)}>
      {content}
    </Link>
  );
};

export default ImageCard;
